import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { IdAssetBundleDoghouse } from "./IdAssetBundleDoghouse";
var mapOutskirtBuildingBundle = new Map([
    [
        IdOutskirtBuildings.Market,
        function (level) { return ({
            data: require("../../assets/packed/market/market" + level + "-0.json"),
            id: "market-" + level,
        }); },
    ],
    [
        IdOutskirtBuildings.Doghouse,
        function (level) { return ({
            data: require("../../assets/outskirts/doghouse/Doghouse_1.png"),
            id: IdAssetBundleDoghouse.Doghouse_1,
        }); },
    ],
    [
        IdOutskirtBuildings.Watertower,
        function (level) { return ({
            data: require("../../assets/outskirts/watertower/Watertower_" + level + ".png"),
            id: "Watertower_" + level,
        }); },
    ],
    [
        IdOutskirtBuildings.Nursery,
        function (level) { return ({
            data: require("../../assets/outskirts/nursery/Nursery_" + level + ".png"),
            id: "Nursery_" + level,
        }); },
    ],
    [
        IdOutskirtBuildings.Library,
        function (level) { return ({
            data: require("../../assets/outskirts/library/Library_" + level + ".png"),
            id: "Library_" + level,
        }); },
    ],
    [
        IdOutskirtBuildings.ExternalBarn,
        function (level) { return ({
            data: require("../../assets/outskirts/barn/externalBarn_" + level + ".png"),
            id: "ExternalBarn_" + level,
        }); },
    ],
    [
        IdOutskirtBuildings.Harbor,
        function (level) { return ({
            data: require("../../assets/outskirts/harbor/Harbor_" + level + ".png"),
            id: "Harbor_" + level,
        }); },
    ],
    [
        IdOutskirtBuildings.Pier,
        function (level) { return ({
            data: require("../../assets/outskirts/pier/Pier_" + level + ".png"),
            id: "Pier_" + level,
        }); },
    ],
    [
        IdOutskirtBuildings.Cafe,
        function (level) { return ({
            data: require("../../assets/outskirts/cafe/Cafe_" + level + ".png"),
            id: "Cafe_" + level,
        }); },
    ],
    [
        IdOutskirtBuildings.TournamentTent,
        function (level) { return ({
            data: require("../../assets/outskirts/tournamenttent/TournamentTent_" + level + ".png"),
            id: "TournamentTent_" + level,
        }); },
    ],
    [
        IdOutskirtBuildings.ThemedEvent,
        function (level, buildingName) { return ({
            data: require("../../assets/outskirts/themedEvent/" + buildingName + ".png"),
            id: "" + buildingName,
        }); },
    ],
]);
export var GetOutskirtBuildingBundle = function (id, level, isAccessible, buildingName) {
    if (isAccessible === void 0) { isAccessible = true; }
    var bundleFn = mapOutskirtBuildingBundle.get(id);
    if (!bundleFn) {
        return {
            data: "",
            id: "outskirt-" + id + "-" + level,
        };
    }
    // Handle special cases
    var hasLevelZeroWhenLocked = id === IdOutskirtBuildings.Nursery ||
        id === IdOutskirtBuildings.Library ||
        id === IdOutskirtBuildings.ExternalBarn;
    if (!isAccessible && hasLevelZeroWhenLocked) {
        level = 0;
    }
    return bundleFn(level, buildingName);
};



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/outskirts/GetOutskirtBuildingBundle.ts
// module id = 1249
// module chunks = 3